function getLatitudeBenefits(membershipBenefits) {
  const membersBenefits = []
  const disclaimer = []
  let disclaimerMarker = ''

  membershipBenefits.forEach(benefit => {
    const hasDisclaimer = !!benefit.disclaimer

    if (hasDisclaimer) {
      disclaimerMarker += '*'
      disclaimer.push(`${disclaimerMarker}${benefit.disclaimer}`)
    }
    membersBenefits.push(`${benefit.details}${hasDisclaimer ? disclaimerMarker : ''}`)
  })

  return {
    membersBenefits: membersBenefits.join(' | '),
    disclaimer: disclaimer.join(', ') + '.'
  }
}

export default getLatitudeBenefits
